<div class="p-3">
  <h5
    class="text-900 text-base flex align-items-center border-bottom-1 border-300 pb-3 mb-6"
  >
    <i class="fa fa-question-circle font-light text-xl text-600 mr-2"></i>
    {{ 'ADMIN.RIGHT_SIDE.QUICK_HELP' | translate }}
  </h5>

  <!-- <div class="border-top-1 border-bottom-1 border-300 py-2 my-3">
    <a href="#" class="text-primary font-bold"
      >
      {{ 'ADMIN.RIGHT_SIDE.GO_TO_PORTAL' | translate }}</a
    >
  </div>

  <h5 class="text-sm font-bold"> {{ 'ADMIN.RIGHT_SIDE.VIDEO_TITLE' | translate }}</h5> -->
  <img
    class="w-full"
    src="/assets/img/help-center-coming-soon-img.svg"
    alt="Image"
  />

  <h5 class="text-base font-bold text-900 mt-5 text-center">
    Quick help will be launching soon.
  </h5>

  <!-- <p>
    {{ 'ADMIN.RIGHT_SIDE.TOP' | translate }}</p>
  <p>
    <strong
      >
      {{ 'ADMIN.RIGHT_SIDE.MIDDLE_BOLD' | translate }}
      </strong
    >
  </p>
  <p>
    {{ 'ADMIN.RIGHT_SIDE.BOTTOM' | translate }}
  </p> -->
</div>
